/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../support/utils';
import { SSO_GET, SSO_SAVE, SSO_UPDATE } from '../actions/SsoActions';
import { LOADING_STATUS } from '../support/constants';
import type { SsoData, SsoReducer } from '../types/ssoTypes';
const INIT_STATE: SsoReducer = {
  loadingStatus: 0,
  error: null,
  data: {},
};

function updateStateWithData(state: SsoReducer, data: SsoData) {
  return { ...state, loadingStatus: LOADING_STATUS.LOADED, error: null, data };
}

function Handler(
  state: SsoReducer,
  action: {
    type: string;
    data: SsoData;
  }
) {
  switch (action.type) {
    case SSO_GET.response:
      return updateStateWithData(state, action.data);

    case SSO_SAVE.response:
      return updateStateWithData(state, action.data);

    case SSO_UPDATE:
      return updateStateWithData(state, action.data);

    default:
      return state;
  }
}

const SSO = reducerWrapper(INIT_STATE, Handler, {
  request: [SSO_GET, SSO_SAVE],
  error: [SSO_GET, SSO_SAVE],
  resetOn: ['APP_CHANGE'],
});
export default SSO;
